<template>
	<b-modal
		ok-only
		centered
		size="xl"
		hide-header
		hide-footer
		v-model="infoModal.show"
		@hide="resetInfoModal"
	>
		<header class="bg-primary tw--mx-6 tw--mt-6 tw-px-6 tw-pt-6 tw-pb-4 tw-rounded-t-md tw-shadow">
			<div class="tw-flex tw-items-center">
				<div class="tw-flex-1">
					<h2 class="tw-text-2xl tw-font-bold tw-text-gray-100">Detalle de Solicitud</h2>
					<p
						class="tw-text-base tw-font-normal tw-text-gray-200"
					>Los datos editados se guardaran una vez presiones el boton</p>
				</div>
				<!-- <b-button
						@click="infoModal.show=false"
						class="tw-bg-transparent tw-text-white tw-border-none tw-shadow-none "
				>-->
				<b-icon icon="x" class="tw-text-3xl tw-text-red-500 tw-cursor-pointer" @click="resetInfoModal"></b-icon>
				<!-- </b-button> -->
			</div>
		</header>
		<div v-if="infoModal.content" class="tw-mt-4">
			<div class="tw-flex">
				<div class="tw-w-96 tw-flex-none tw-text-justify">
					<h3 class="tw-text-xl tw-font-bold tw-text-gray-800">Informacion</h3>
					<p class="tw-text-gray-600">Aqui se muestra datos NO modificables de la asignacion</p>

					<b-card class="bg-primary tw-text-white tw-mt-4">
						<div class="tw-space-y-4">
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Cliente</div>
								<div class="tw-text-lg tw-font-normal tw-text-white">{{infoModal.content.client.name}}</div>
							</div>
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Descripcion</div>
								<div class="tw-text-lg tw-font-normal tw-text-white">{{infoModal.content.description}}</div>
							</div>
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Direccion</div>
								<div class="tw-text-lg tw-font-normal tw-text-white">{{infoModal.content.direction}}</div>
							</div>
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Nombre Propietario</div>
								<div class="tw-text-lg tw-font-normal tw-text-white">{{infoModal.content.contactName}}</div>
							</div>
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Telefono Propietario</div>
								<div class="tw-text-lg tw-font-normal tw-text-white">{{infoModal.content.phoneNumber}}</div>
							</div>
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Fecha de Inspeccion</div>
								<div
									class="tw-text-lg tw-font-normal tw-text-white"
								>{{$m.utc(infoModal.content.inspectionDateTime).format('YYYY-MM-DD HH:mm')}}</div>
							</div>
							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Fecha de Entrega</div>
								<div
									class="tw-text-lg tw-font-normal tw-text-white"
								>{{$m.utc(infoModal.content.deliveryDateTime).format('YYYY-MM-DD HH:mm')}}</div>
							</div>

							<div>
								<div
									class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-200"
								>Documentos</div>
								<document-list>
									<document-list-item
										v-for="(doc, docIndex) in infoModal.content.documents"
										:key="docIndex"
										:document="doc"
										download
										:remove="false"
										class="tw-bg-white tw-text-gray-600"
									></document-list-item>
								</document-list>
							</div>
						</div>
					</b-card>
				</div>
				<div class="tw-flex-none tw-w-1 tw-bg-white tw-rounded-full tw-mx-10"></div>
				<div class="tw-flex-1 tw-text-justify tw-overflow-auto" style="height:max-content">
					<validation-observer v-slot="{handleSubmit}" ref="formValidator">
						<b-form role="form" class="tw-mt-7" @submit.prevent="handleSubmit(onSubmit)">
							<div class="tw-flex tw-space-x-3 tw-items-end tw-justify-between">
								<div v-if="$isExpertAdmin">
									<div
										class="tw-uppercase tw-text-xs tw-tracking-widest tw-font-base tw-text-gray-600"
									>Estado</div>
									<div
										class="tw-text-lg tw-font-normal tw-text-black"
									>{{ currentStatus?currentStatus.text : 'No Yet Updated'}}</div>
								</div>
								<!-- Statutes -->
								<base-input
									v-else
									name="estado"
									label="Estado"
									class="tw-flex-1"
									label-classes="tw-mb-1"
									group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
									:rules="{ required: true }"
									v-model="infoModal.content.status"
									@input="errorMessage = null"
								>
									<b-select :options="statuses" v-model="infoModal.content.status"></b-select>
								</base-input>
								<div
									v-if="currentStatus"
									class="tw-w-10 tw-h-10 tw-rounded-full tw-flex-none tw-shadow"
									:style="{ backgroundColor: currentStatus.color }"
								></div>
							</div>

							<base-input
								name="observacion"
								label="Observacion"
								label-classes="tw-mb-1"
								group-class="mb-0 tw-mt-4 tw-rounded"
								:rules="{ required: true }"
								v-model="infoModal.content.observation"
								@input="errorMessage = null"
							>
								<b-textarea
									rows="4"
									v-model="infoModal.content.observation"
									class="tw-border tw-border-solid tw-border-gray-300"
								></b-textarea>
							</base-input>

							<!-- Documents -->
							<base-input
								class="tw-mt-3"
								label-classes="tw-mb-1"
								group-class="mb-0 tw-overflow-hidden"
								name="documents"
								label="Agregar Documentos"
							>
								<b-form-file
									multiple
									:value="newDocuments[0]"
									:state="Boolean(newDocuments)"
									placeholder="Choose a file or drop it here..."
									drop-placeholder="Drop file here..."
									class="tw-border tw-rounded tw-overflow-hidden tw-border-solid tw-border-gray-300"
									@input="newDocuments = $event"
								></b-form-file>
							</base-input>

							<div class="tw-mt-2 tw-flex tw-flex-col tw-space-y-2">
								<div
									v-for="(doc, docIndex) in newDocuments"
									:key="docIndex"
									class="tw-bg-gray-200 tw-text-gray-800 tw-w-full tw-rounded tw-py-1 tw-px-2 tw-text-left tw-relative tw-flex tw-items-center tw-space-x-2 tw-overflow-hidden"
								>
									<template v-if="loading">
										<i v-if="!uploaded.includes(doc.name)" class="fas fa-spinner fa-spin tw-flex-none"></i>
										<i v-else class="fas fa-check tw-flex-none text-primary"></i>
									</template>
									<div class="tw-flex-1 tw-truncate">{{ doc.name }}</div>
									<button type="button" @click="newDocuments.splice(docIndex, 1)">
										<b-icon icon="x" class="tw-text-red-500 tw-text-xl tw-flex-none"></b-icon>
									</button>
								</div>
							</div>

							<!-- Location Picker -->
							<location-picker expanded-modal v-model="infoModal.content.location"></location-picker>

							<!-- Actions -->
							<footer class="tw-mt-8 tw-flex tw-justify-end">
								<base-button type="danger" @click="resetInfoModal">Cancelar</base-button>
								<base-button type="primary" native-type="submit" :loading="loading">Guardar Cambios</base-button>
							</footer>
						</b-form>
					</validation-observer>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { STATUSES } from '../../consts'
import { RequestsAPI } from '../../firebase/api.firebase'
import DocumentList from '../DocumentList.vue'
import DocumentListItem from '../DocumentListItem.vue'
export default {
	name: 'ModalRequestInfo',
	components: {
		DocumentList,
		DocumentListItem,
	},
	data: () => ({
		errorMessage: null,
		uploaded: [],
		loading: false,
		newDocuments: [],
		infoModal: {
			show: false,
			content: null
		},
		statuses: STATUSES
	}),
	computed: {
		...mapGetters('auth', ['$isExpertAdmin']),
		currentStatus() {
			if (!this.infoModal.content) return
			return this.statuses.find(status => {
				return status.value === this.infoModal.content.status
			})
		}
	},
	created() {
		this.$emit('show', this.showInfo)
	},
	methods: {
		showInfo(item) {
			this.infoModal.content = item
			this.infoModal.show = true
		},
		resetInfoModal() {
			this.uploaded = []
			this.newDocuments = []
			this.loading = false
			this.infoModal.show = false
			this.$refs.formValidator.reset()
			setTimeout(() => {
				this.infoModal.content = null
			}, 500);
		},
		async onSubmit() {
			this.loading = true
			let newDocuments = []
			if (this.newDocuments.length) {
				newDocuments = await RequestsAPI
					.uploadFiles(this.newDocuments, (_, file) => {
						this.uploaded.push(file.name)
					})
			}
			const { status, location, observation, documents } = this.infoModal.content

			await RequestsAPI.update(
				this.infoModal.content.id, {
				status, location, observation,
				documents: documents.concat(newDocuments)
			})
			// await this.infoModal.content.ref.update({
			// 	status, location, observation,
			// 	documents: documents.concat(newDocuments)
			// })

			this.resetInfoModal()
		}
	}
}
</script>
